import {useEffect, useState} from "react";
import {Affix, Button, Dropdown, Input, List, Menu, Modal, Tree} from "antd";
import {
  DownOutlined,
  MoreOutlined
} from "@ant-design/icons";
import i18next from "i18next";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as Setting from "../../conf/Setting";
import moment from "moment";
import {v4 as uuidv4} from "uuid";
import * as IconFont from "../common/IconFont";
import "../../assets/styles/user/OrganizationTree.less";

export const OrganizationTree = (props) => {
  const {treeData, expandedNodeKeys, selectedNodeKeys, onTreeNodeExpand, onTreeNodeSelect,
    onLoadTreeData, onAddDepartment, onEditDepartment, onDelDepartment, onAddOrganization, onEditOrganization,
    onDelOrganization, account, onSearchKey, searchList, onSelectSearch, selectedSearch, keyword} = props;
  const [data, setData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [delDeptModalVisible, setDelDeptModalVisible] = useState(false);
  const [delOrgModalVisible, setDelOrgModalVisible] = useState(false);
  const [opOrganization, setOpOrganization] = useState({});
  const [opDepartment, setOpDepartment] = useState({});
  const [titleNodeName, setTitleNodeName] = useState("org-tree-node-title");

  const newOrganization = () => {
    const randomName = Setting.getRandomName();
    return {
      owner: Setting.Admin,
      uid: uuidv4(),
      createdTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      updatedTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      displayName: `新组织 - ${randomName}`,
      code: "",
      websiteUrl: "",
      favicon: "",
      passwordType: "salt",
      PasswordSalt: "",
      phonePrefix: "86",
      defaultAvatar: "",
      defaultApplication: "",
      tags: [],
      masterPassword: "",
      enableSoftDeletion: false,
      isProfilePublic: true,
      needActivation: true, // 组织内用户需要激活
      isAdmin: false, // 是否是管理员组织
      accountItems: [
        {name: "Organization", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {name: "ID", visible: true, viewRule: "Public", modifyRule: "Immutable"},
        {name: "Name", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {name: "Display name", visible: true, viewRule: "Public", modifyRule: "Self"},
        {Name: "IdCard", visible: true, ViewRule: "Admin", ModifyRule: "Admin"},            // 身份证号码
        {name: "Password", visible: true, viewRule: "Self", modifyRule: "Self"},
        {name: "Avatar", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "User type", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {name: "Gender", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Email", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Phone", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Country/Region", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Location", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Affiliation", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Title", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Homepage", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Bio", visible: true, viewRule: "Public", modifyRule: "Self"},
        {name: "Tag", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {name: "Departments", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {Name: "Post", visible: true, ViewRule: "Public", ModifyRule: "Admin"},             // 岗位
        {Name: "Student status", visible: true, ViewRule: "Admin", ModifyRule: "Admin"},    // 学籍状态
        {Name: "Employment status", visible: true, ViewRule: "Admin", ModifyRule: "Admin"}, // 任职状态
        {Name: "Leave date", visible: true, ViewRule: "Admin", ModifyRule: "Admin"},        // 离职时间
        {name: "Signup application", visible: true, viewRule: "Public", modifyRule: "Admin"},
        {name: "Roles", visible: true, viewRule: "Public", modifyRule: "Immutable"},
        {name: "Permissions", visible: true, viewRule: "Public", modifyRule: "Immutable"},
        {name: "Properties", visible: false, viewRule: "Admin", modifyRule: "Admin"},
        {name: "Is admin", visible: true, viewRule: "Admin", modifyRule: "Admin"},
        {name: "Is global admin", visible: true, viewRule: "Admin", modifyRule: "Admin"},
        {Name: "Is Active", visible: true, ViewRule: "Admin", ModifyRule: "Immutable"},     // 激活状态
        {name: "Is forbidden", visible: true, viewRule: "Admin", modifyRule: "Admin"},
        {name: "Created time", visible: true, viewRule: "Admin", modifyRule: "Immutable"},      // 创建时间
        {name: "Last login time", visible: true, viewRule: "Admin", modifyRule: "Immutable"},  // 最后登录时间
        {name: "3rd-party logins", visible: true, viewRule: "Self", modifyRule: "Self"},
        {name: "Is deleted", visible: true, viewRule: "Admin", modifyRule: "Admin"},
        {name: "User source", visible: true, viewRule: "Admin", modifyRule: "Admin"},
        {name: "Visit Apps", visible: true, viewRule: "Admin", modifyRule: "Admin"},
      ],
    };
  };

  const newDepartment = (owner, pid, organId, organName, level) => {
    const randomName = Setting.getRandomName();
    return {
      uid: uuidv4(), // 必有
      owner: owner, // 必有
      pid: pid, // 必有
      pidName: "", // 必为空
      organId: organId,  // 必有
      organName: organName, // 必有
      displayName: `新部门 - ${randomName}`,  // 可为空
      code: "",  // 必有
      createdTime: "",
      updatedTime: "",
      level: level, // 必有 当前的层级
    };
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      if (document.getElementsByClassName("organization-tree").length > 0) {
        const width = document.getElementsByClassName("organization-tree")[0].clientWidth;
        if (width !== 270) {
          setTitleNodeName("org-tree-node-title-resize");
        } else {
          setTitleNodeName("org-tree-node-title");
        }
      }
    });
    if (keyword === "") {
      resizeObserver.observe(document.getElementsByClassName("organization-tree")[0]);
    }
    return (() => {
      // 在不需要监听的时候或离开界面的时候销毁
      resizeObserver.disconnect();
    });
  }, []);

  useEffect(() => {
    setExpandedKeys(expandedNodeKeys);
  }, [expandedNodeKeys]);

  useEffect(() => {
    const list = [...treeData];
    copyDataToTree(list);
    setData(list);
  }, [treeData]);

  const onLoadData = (treeNode) => {
    return new Promise((resolve) => {
      if (treeNode.children) {
        resolve();
        return;
      }

      OrganizationBackend.getDepartments(Setting.Admin, treeNode?.isOrganization ? treeNode.uid : treeNode.organId, treeNode?.isOrganization ? "0" : treeNode.uid)
        .then((res) => {
          if (res.msg === undefined) {
            const treeList = res.reverse();

            onLoadTreeData(treeNode, treeList);
          } else {
            Setting.showResponseMessage(res.msg);
          }
          resolve();
        });
    });
  };

  const handleClickOrganizationMenu = (menuItem) => {
    menuItem.domEvent.stopPropagation();
    if (menuItem.key === "1") {
      let department = null;
      if (keyword === "") {
        department = newDepartment(menuItem.item.props.organization.owner, "0", menuItem.item.props.organization.uid, menuItem.item.props.organization.displayName, menuItem.item.props.organization.level + 1);
      } else {
        department = newDepartment(Setting.Admin, "0", menuItem.item.props.organization.uid, menuItem.item.props.organization.displayName, 1);
      }
      onAddDepartment(department, menuItem.item.props.organization);
    } else if (menuItem.key === "2") {
      onEditOrganization(menuItem.item.props.organization.uid, menuItem.item.props.organization.displayName);
    } else {
      setOpOrganization(menuItem.item.props.organization);
      setDelOrgModalVisible(true);
    }
  };

  const handleClickDepartmentMenu = (menuItem) => {
    menuItem.domEvent.stopPropagation();
    if (menuItem.key === "1") {
      let newDept = null;
      if (keyword === "") {
        newDept = newDepartment(menuItem.item.props.department.owner, menuItem.item.props.department.uid, menuItem.item.props.department.organId, menuItem.item.props.department.organName, menuItem.item.props.department.level + 1);
      } else {
        const pathLength = menuItem.item.props.department.displayWholeName.split("/").length;
        newDept = newDepartment(Setting.Admin, menuItem.item.props.department.uid, menuItem.item.props.department.organId, menuItem.item.props.department.organName, pathLength);
      }
      onAddDepartment(newDept, menuItem.item.props.department);
    } else if (menuItem.key === "2") {
      OrganizationBackend.getDepartment(menuItem.item.props.department.uid)
        .then((res) => {
          // const {content, icon, ...department} = menuItem.item.props.department;
          if (res.msg === undefined) {
            onEditDepartment(res);
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    } else {
      setOpDepartment(menuItem.item.props.department);
      setDelDeptModalVisible(true);
    }
  };

  const handleClickAddNewOrganization = () => {
    const organization = newOrganization();
    OrganizationBackend.addOrganization(organization)
      .then((res) => {
        if (res.status === "ok") {
          onAddOrganization(organization.uid);
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  };

  const handleDelDepartment = () => {
    setConfirmLoading(true);
    // eslint-disable-next-line unused-imports/no-unused-vars
    const {isOrganization, content, icon, ...department} = opDepartment;
    setConfirmLoading(true);
    OrganizationBackend.deleteDepartment(department)
      .then((res) => {
        setConfirmLoading(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("department:Department deleted successfully"));
          setDelDeptModalVisible(false);
          onDelDepartment(department);
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }
      )
      .catch(error => {
        setConfirmLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const handleDelOrganization = () => {
    setConfirmLoading(true);
    // eslint-disable-next-line unused-imports/no-unused-vars
    const {isOrganization, content, icon, children, ...organization} = opOrganization;
    OrganizationBackend.deleteOrganization(organization)
      .then((res) => {
        setConfirmLoading(false);
        if (res.status === "ok") {
          setDelOrgModalVisible(false);
          Setting.showMessage("success", i18next.t("organization:Organization deleted successfully"));
          onDelOrganization(organization);
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }
      )
      .catch(error => {
        setDelOrgModalVisible(false);
        setConfirmLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const attachMenu = (isOrganization, data) => {
    let menuItems;
    let onClick;
    if (isOrganization) {
      menuItems = [
        {
          label: i18next.t("department:Add New Department"),
          key: "1",
          organization: data,
        },
        {
          label: i18next.t("organization:Edit Organization"),
          key: "2",
          organization: data,
        },
        {
          label: i18next.t("organization:Delete Organization"),
          key: "3",
          organization: data,
        },
      ];
      // 管理员组织不可新增部门和删除自身
      if (Setting.isAdminOrganization(data.uid)) {
        menuItems.pop();
        menuItems.shift();
      }
      onClick = handleClickOrganizationMenu;
    } else {
      menuItems = [
        {
          label: i18next.t("department:Edit Department"),
          key: "2",
          department: data,
        },
        {
          label: i18next.t("department:Delete Department"),
          key: "3",
          department: data,
        },
      ];

      let pathLength = 0;
      if (data.displayWholeName) {
        pathLength = data.displayWholeName.split("/").length;
      }
      if (data.level <= 6 || pathLength < 8) {
        menuItems.unshift({
          label: i18next.t("department:Add New Department"),
          key: "1",
          department: data,
        });
      }
      onClick = handleClickDepartmentMenu;
    }

    return <Menu
      onClick={onClick}
      items={menuItems}
    />;
  };

  const onNodeSelect = (selectedKeyValues, e) => {
    e.nativeEvent.stopPropagation();
    if (selectedKeyValues.length === 0) {
      return;
    }
    onTreeNodeSelect(selectedKeyValues, e.node);
  };

  const onNodeExpand = (expandedKeysValue, e) => {
    e.nativeEvent.stopPropagation();
    onTreeNodeExpand(expandedKeysValue, e.node);
  };

  const copyDataToTree = (data) => {
    for (let i = 0; i < data.length; ++i) {
      if (Setting.isAdminOrganization(data[i]?.uid)) {
        data[i].icon = <IconFont.AdminIcon style={{fontSize: 16}} />;
      } else {
        data[i].icon = <IconFont.OrganizationIcon style={{fontSize: 16}} />;
      }
      data[i].isLeaf = data[i].childNum === 0;
      if (data[i]?.children?.length > 0) {
        copyDataToTree(data[i].children);
      }
    }
  };

  return <div style={{textAlign: "center"}}>
    <Input.Search
      style={{
        marginBottom: 8,
      }}
      allowClear={true}
      defaultValue={keyword}
      placeholder={i18next.t("organization:Please input organzation or department name")}
      onSearch={(value) => {
        onSearchKey(value);
      }}
    />
    {
      keyword !== "" ?
        <List
          className="user-search-list"
          size="small"
          split={false}
          dataSource={searchList}
          renderItem={item => {
            const itemClassName = item.uid === selectedSearch?.uid ? "user-search-list-item-selected" : "";
            return <List.Item className={["user-search-list-item-normal", itemClassName]}
              onClick={() => {
                onSelectSearch(item);
              }}>
              <IconFont.OrganizationIcon style={{marginLeft: "5px", marginRight: "5px", fontSize: 16}} />
              <span className="user-search-list-item-title" title={item.displayWholeName}>{item.displayWholeName}</span>
              <Dropdown overlay={attachMenu(item.isDept ? false : true, item)}
                onClick={(e => e.stopPropagation())}>
                <MoreOutlined />
              </Dropdown>
            </List.Item>;
          }}
        />
        :
        <Tree
          blockNode={true}
          className="organization-tree"
          showIcon={true}
          onExpand={onNodeExpand}
          expandedKeys={expandedKeys}
          onSelect={onNodeSelect}
          selectedKeys={selectedNodeKeys}
          switcherIcon={<DownOutlined />}
          fieldNames={{title: "displayName", key: "uid", children: "children"}}
          titleRender={(node) => {
            return (
              <>
                <span className={`org-tree-node-title ${titleNodeName}-${node.level}`}>{node.displayName}</span>
                {
                  !Setting.isAdminUser(account) ? null :
                    <Dropdown overlay={attachMenu(node?.isOrganization ? true : false, node)}
                      onClick={(e => e.stopPropagation())}>
                      <MoreOutlined />
                    </Dropdown>
                }
              </>
            );
          }}
          treeData={data}
          loadData={onLoadData}
        />
    }
    <Affix offsetBottom={20}>
      <Button block className="btn-new-organization" icon={<IconFont.PlusIcon />}
        onClick={handleClickAddNewOrganization}>{i18next.t("organization:Create New Organization")}</Button>
    </Affix>
    <Modal
      title={i18next.t("department:Delete Department")}
      visible={delDeptModalVisible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      width={560}
      onOk={handleDelDepartment}
      onCancel={() => {setDelDeptModalVisible(false);}}
    >
      <p>{i18next.t("department:Sure to delete this department")}</p>
    </Modal>
    <Modal
      title={i18next.t("organization:Delete Organization")}
      visible={delOrgModalVisible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      width={560}
      onOk={handleDelOrganization}
      onCancel={() => {setDelOrgModalVisible(false);}}
    >
      <p>{i18next.t("organization:Sure to delete organization")}</p>
    </Modal>
  </div>;
};

export default OrganizationTree;
